// components/DraggableRow.js
import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const type = "DraggableBodyRow";

const DraggableBodyRow = ({ index, moveRow, onDropRow, className, style, ...restProps }) => {
  const ref = useRef();

  const [, drop] = useDrop({
    accept: type,
    hover(item, monitor) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type,
    item: { index },
    end: (item, monitor) => {
      if (typeof onDropRow === "function") {
        onDropRow(item, monitor);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <tr
      ref={ref}
      style={{
        cursor: "move",
        opacity: isDragging ? 0.5 : 1,
        ...style,
      }}
      className={className}
      {...restProps}
    />
  );
};

export default DraggableBodyRow;
